import React from "react"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import { ELanguage, IQuestion, IQuestionTableItem } from "../../models"
import { FloatingActionButton } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import TableActionBar from "../layout/TableActionBar"
import AddQuestionGroupDialog from "./AddQuestionGroupDialog"
import PunchQuestionBodyTable from "./PunchQuestionBodyTable"
import moment from "moment"
import * as timeHelper from "../../helpers/timeHelper"
import _ from "lodash"
interface IProps {
    selectedLanguages: ELanguage[]
    punchIn: boolean
    readonly: boolean
    questions: IQuestion[]
    handleChange(questions: IQuestion[]): void
}
interface IState {
    openAddQuestionDailog: boolean
    search: string
    selectedQuestionGroupIds: number[]
    editQuestionGroupId: number
}

export default class PunchQuestionBody extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            openAddQuestionDailog: false,
            search: "",
            selectedQuestionGroupIds: [],
            editQuestionGroupId: null
        }
        autobind(this)
    }

    render() {
        const searchedQuestionGroupIds = this.props.questions
            .filter(i =>
                (i.Name && i.Name.toLowerCase().includes(this.state.search.toLowerCase())) ||
                (i.Title && i.Title.toLowerCase().includes(this.state.search.toLowerCase())) ||
                i.Body.toLowerCase().includes(this.state.search.toLowerCase())
            )
            .map(i => i.GroupId)
        const searchedQuestionUniqueGroupIds: number[] = []
        searchedQuestionGroupIds.forEach(i => {
            !searchedQuestionUniqueGroupIds.includes(i) &&
                searchedQuestionUniqueGroupIds.push(i)
        })

        const questionTableItems: IQuestionTableItem[] = searchedQuestionUniqueGroupIds
            .map(groupId => {
                const groupQuestions = this.props.questions.filter(i => i.GroupId === groupId)
                return {
                    Id: groupId,
                    GroupId: groupId,
                    Name: groupQuestions[0].Name,
                    PunchIn: groupQuestions[0].PunchIn,
                    ModifiedDate: moment(timeHelper.keepConvertUTCToLocal(groupQuestions[0].ModifiedDate)).format("MM/DD/YYYY"),
                    Child: groupQuestions[0].Child
                }
            })
            
        return (
            <div>
                {!this.props.readonly &&
                    <FloatingActionButton data-intercom-target={this.props.punchIn ? "PunchInQuestions-Btn-Add" : "PunchOutQuestions-Btn-Add"} className="fixed-add" style={{ top: -28, right: 20 }} secondary onTouchTap={() => this.setState({ openAddQuestionDailog: true })}>
                        <ContentAdd />
                    </FloatingActionButton>
                }
                <div style={{ paddingTop: 10 }}>
                    <TableActionBar
                        rowSelectionCount={this.state.selectedQuestionGroupIds.length}
                        singleSelectedMessage={strings.Question}
                        multipleSelectedMessage={strings.X_Questions}
                        onSearch={search => this.setState({ search, selectedQuestionGroupIds: [] })}
                        searchText={this.state.search}
                        onDeleteClick={() => {
                            const undeletedQuestions: IQuestion[] = []
                            this.props.questions.forEach(i => {
                                if (!this.state.selectedQuestionGroupIds.includes(i.GroupId)) {
                                    i.GroupId = i.GroupId - this.state.selectedQuestionGroupIds.filter(e => e < i.GroupId).length
                                    undeletedQuestions.push(i)
                                }
                            })
                            this.setState({ selectedQuestionGroupIds: [] })
                            this.props.handleChange(undeletedQuestions)
                        }}
                        title={this.props.punchIn ? strings.Punch_In_Questions : strings.Punch_Out_Questions}
                    />
                    <div style={{ maxHeight: 250, overflowY: "auto" }}>
                        {!questionTableItems.length ?
                            <h3 style={{ textAlign: "center", marginTop: 25 }}>
                                {this.props.punchIn ? strings.No_Punch_IN_Questions : strings.No_Punch_OUT_Questions}
                            </h3> :
                            <PunchQuestionBodyTable
                                readonly={this.props.readonly}
                                punchIn={this.props.punchIn}
                                questionTableItems={questionTableItems}
                                selectedGroupIds={this.state.selectedQuestionGroupIds}
                                handleSelectQuestions={selectedQuestionGroupIds => this.setState({ selectedQuestionGroupIds })}
                                handleUpdateQuestion={editQuestionGroupId => !this.props.readonly && this.setState({ openAddQuestionDailog: true, editQuestionGroupId })}
                                handleReoderQuesetions={groupIdOrder => {
                                    let reorderedQuestions: IQuestion[] = []
                                    groupIdOrder.forEach((i, index) => {
                                        const groupQuestions = _.cloneDeep(this.props.questions.filter(e => e.GroupId === i))
                                        groupQuestions.forEach(e => {
                                            e.GroupId = index
                                        })
                                        reorderedQuestions = reorderedQuestions.concat(groupQuestions)
                                    })

                                    this.props.handleChange(reorderedQuestions)
                                }}
                            />
                        }
                    </div>
                </div>
                {this.state.openAddQuestionDailog &&
                    <AddQuestionGroupDialog
                        newGroupId={this.props.questions.length ?
                            Math.max(...this.props.questions.map(i => i.GroupId)) + 1 :
                            0
                        }
                        editQuestionGroupId={this.state.editQuestionGroupId}
                        selectedLanguages={this.props.selectedLanguages}
                        punchIn={this.props.punchIn}
                        questions={this.props.questions}
                        handleAdd={newQuestions => {
                            this.setState({ openAddQuestionDailog: false, editQuestionGroupId: null })
                            this.props.handleChange(this.props.questions.concat(newQuestions))
                        }}
                        handleUpdate={editQuestions => {
                            const { questions } = this.props
                            editQuestions.forEach(i => {
                                const indexOf = questions.findIndex(e => e.GUId === i.GUId)
                                if (indexOf > -1) {
                                    questions[indexOf] = i
                                }
                                else {
                                    questions.push(i)
                                }
                            })
                            this.setState({ openAddQuestionDailog: false, editQuestionGroupId: null })
                            this.props.handleChange(questions)
                        }}
                        handleClose={() => this.setState({ openAddQuestionDailog: false, editQuestionGroupId: null })}
                    />
                }
            </div>
        )
    }
}